import { SignInPage } from "@backstage/core-components";
import { microsoftAuthApiRef } from "@backstage/frontend-plugin-api";
import { SignInPageBlueprint } from "@backstage/plugin-app-react";

export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          auto
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Microsoft',
            message: 'Sign in using microsoft',
            apiRef: microsoftAuthApiRef,
          }}
        />
      ),
  },
});